export const RESET_MODULES = 'RESET_MODULES';
export const SET_MODULES = 'SET_MODULES';
